<template>
  <div class="myhome-data xs-12 m-8 l-9">
    <div class="myhome-data__title dea-heading--medium-xxl" tabindex="0">
      I miei dati
    </div>
    <UserData :link-color="user.targetCss.colorMod" :modify-last-name="true" :user="user" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserData from "../components/UserData";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MyProfileData",
  components: { UserData },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    setFocus("myhome-data__title");
  },
  activated() {
    setFocus("myhome-data__title");
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-data {
  &__title {
    margin-bottom: $space-large;
  }
}
</style>
